








































// Importing components
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import LayoutApp from '@/layputs/LayoutApp.vue';
import TheFormProducts1 from '@/components/products/TheFormProducts1.vue';
import TheFormProducts2 from '@/components/products/TheFormProducts2.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BaseAlertList from '@/ui/BaseAlertList.vue';
// Importing functions
import {validateProduct} from '@/ts/products/validate-product';
import {updateProduct} from '@/ts/products/update-product';
import {getProduct} from '@/ts/products/get-product';
import {getFormData} from '@/ts/helpers';
// Importing variables
import {InvalidImage} from '@/ts/variables';

export default {
    name: 'PageCategoriesUpdate',
    components: {
        BaseCard,
        BaseAlertList,
        BaseLoadingAnimation,
        LayoutApp,
        TheFormProducts1,
        TheFormProducts2,
    },
    props: {},
    data() {
        return {
            data: Object(),
            items: Array(),
            errors: Array(),
            first_page: Boolean(true),
        };
    },
    methods: {
        next() {
            this.first_page = false;
        },
        back() {
            this.first_page = true;
        },
        onSubmit() {
            this.errors = [];

            validateProduct(this.errors, this.data);

            if (this.errors.length === 0) {
                this.$store.dispatch('setLoadingOn');

                if (this.data.image.length === 0) { delete this.data.image; }
                this.data.tags = JSON.stringify(this.data.tags);
                this.data.ingredients = JSON.stringify(this.data.ingredients);
                this.data.addons = JSON.stringify(this.data.addons);
                this.data.variations = JSON.stringify(this.data.variations);
                const formData = getFormData(this.data);
                formData.append('_method', 'PUT');

                updateProduct(formData as any, this.$route.params.id, this.$route.params.product_id).then(() => {
                    this.$router.push({ name: 'products', params: {
                        id: this.$route.params.id,
                        category_id: this.$route.params.category_id,
                    }});
                }).catch((error) => {
                    if (error.response.data.errors.image[0] === 'The image has invalid image dimensions.') {
                        this.data.tags = JSON.parse(this.data.tags);
                        this.data.ingredients = JSON.parse(this.data.ingredients);
                        this.data.addons = JSON.parse(this.data.addons);
                        this.data.variations = JSON.parse(this.data.variations);
                        this.errors.push(InvalidImage);
                    }
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants' },
        }, {
            text: 'Категории',
            to: { name: 'categories', params: { id: this.$route.params.id} },
        }, {
            text: 'Продукти',
            to: {
                name: 'products',
                params: {
                    id: this.$route.params.id,
                    category_id: this.$route.params.category_id,
                },
            },
        }, {
            text: 'Редактиране',
        }];
        // Initializing the user data object
        this.data = {
            name: '', description: '', is_active: '1',
            cook_time: '', code: '', kcal: '', tags: [],
            addons: [], ingredients: [], image: {},
            menu_category_id: '', variations: { old: [], created: [], deleted: [] },
        };
        this.$store.dispatch('setLoadingOn');
        // Fetching data from the API
        getProduct(this.data, this.$route.params.id, this.$route.params.product_id).finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
